import { uploadImage } from "../CloudStorage/uploadImage";

const getExtensionFromType = (type = "") => {
  const extension = type.split("/")[1];
  return extension ? extension.split(";")[0] : "jpg";
};

export const isHttpImageUrl = (value) =>
  typeof value === "string" && /^https?:\/\//i.test(value);

export const uploadRemoteImage = async (imageUrl, filePrefix = "profile") => {
  const response = await fetch(imageUrl);

  if (!response.ok) {
    throw new Error("Failed to download profile image");
  }

  const blob = await response.blob();
  const extension = getExtensionFromType(blob.type);
  const file = new File([blob], `${filePrefix}-${Date.now()}.${extension}`, {
    type: blob.type || "image/jpeg",
  });

  return uploadImage(file);
};
